// This is a custom section renderer, which is specific to CommsPlanSectionTypes.TEXT and renderd a text field with
// a unique name which allows the server to determine what updates to make when saving
import React, {Fragment} from "react";
import ReactHookFormError from "./ReactHookFormError";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";

const FormItemToggle = ({ heading, name, formSectionName, control, register, formErrors }) =>
{
    const sliderGroupStyle = {
        display: 'grid',
        gridTemplateColumns: '4fr 1fr',
        marginTop: '15px',
        fontSize: 'larger'
    }

    const elementName = formSectionName === undefined ? name : formSectionName + '.' + name ;

    return (
        <Fragment key={name}>
            <div className='form-group' style={{...sliderGroupStyle, fontSize: 'normal'}}>
                <label style={{fontSize: 'normal'}}>{heading}</label>
                <div style={{justifySelf: 'right'}}>
                    <FormToggle readOnly={false} control={control} name={elementName}/>
                </div>
                <ReactHookFormError formErrors={formErrors} name={name}/>
            </div>
        </Fragment>
    )
}

export default FormItemToggle ;
